import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Subtitle, Description, Titlespan2 } from '../../components/title/index';
import Button from '../../components/button';
import Image from '../../components/image/index';
import AboutImg from '../../assets/images/about/about-img.png';
import './about.scss';

function About({ title, subtitle, body, subtitle2, body2, width}) {
    return (
        <section className="about-wrapper gradient-color" id="about">
            <Container>
                <Row>
                    <Col md={width ? width : 6}>
                        <div className="about-content-block main-title-wrapper">
                            <Subtitle
                                Class="sitemain-subtitle"
                                Name={title}
                            />
                            <Subtitle
                                Class="site-subtitle2"
                                Name={subtitle}
                            />

                            <Description
                                Class="about-dec about-dec-1"
                                Name={body}
                            />
                            <Titlespan2
                                Class="about-twosub-title"
                                Name={subtitle2}
                                Label=""
                            />
                            <Description
                                Class="about-dec"
                                Name={body2}
                            />
                            <Button
                                Class="button1 button4 btn d-none"
                                Name="HIRE US NOW"
                                Title="gradient-color"
                                BtnIcon="btn-icon gradient-color1"
                            />
                        </div>
                    </Col>
                    <Col sm={6}>
                        <div className="about-image">
                            {/*<Image Path={AboutImg} Class="about-img" />*/}
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default About;
